/** Tab value constants shared by `PickupInfoGridTab` and group-only shipment UI. */
export const PICKUP_INFO_GRID_TABS = {
  shipmentDetailsTab: 'shipmentDetailsTab',
  pickupHistoryTab: 'pickupHistoryTab'
} as const;

export type PickupInfoGridTabValue =
  (typeof PICKUP_INFO_GRID_TABS)[keyof typeof PICKUP_INFO_GRID_TABS];
